module.exports = "<section>\n    <section head></section>\n    <div class=\"tablesection\">\n        <div class=\"tablecontainer col-md-12 col-lg-11\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>\n\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/views/general_network/top_ja3.html
 ** module id = 620
 ** module chunks = 0
 **/